















import Vue from "vue"
import MaterialIcon, {
  OUTLINED,
} from "~/components/guideline/icon/MaterialIcon.vue"

export default Vue.extend({
  components: {
    MaterialIcon,
  },
  props: {
    materialIconName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      iconType: {
        OUTLINED,
      },
    }
  },
  methods: {
    emitClickEvent() {
      this.$emit("click")
    },
  },
})
